/**
 * Application configuration
 */

const appConfig = {
  // Logo configuration
  logo: {
    // Set to the URL of your logo image
    // Example: "/assets/logo.png" or "https://example.com/logo.png"
    // Leave empty to use the text version
    url: "/assets/logo.svg",
  },

  // Theme configuration
  theme: {
    // Primary color (green) - even darker shade for better text readability
    primary: "#1a8f45",
    // Dark mode color
    dark: "#0f0f0f",
    // Light mode color
    light: "#f4f2ed",
  }
};

export default appConfig;
